import { print } from "graphql";
import { useQuery } from "react-query";
import { getFreshAccessToken } from "../use-user";

export const useTesQuery = (query, variables, options = {}) => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["tes", query, variables],
    queryFn: () => {
      const accessToken = getFreshAccessToken();
      return fetch(`${process.env.REACT_APP_TES_URL}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-client-id": process.env.REACT_APP_CLIENT_ID || "lego-test",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ query: print(query), variables }),
      }).then((res) => res.json());
    },
    ...options,
  });

  return { data, isLoading, error, refetch };
};
